import { FC } from 'react';

import { TextTooltip } from 'components/ui';

interface LineTextSelectFieldProps {
  title: string;
  value: string | string[];
  onClick: () => void;
}

export const LineTextSelectField: FC<LineTextSelectFieldProps> = ({
  title,
  value,
  onClick,
}) => (
  <div
    className="flex items-center gap-1 cursor-pointer tpg-c2"
    onClick={onClick}
  >
    <span className="shrink-0 text-tpg_base">{title}</span>
    <TextTooltip
      value={Array.isArray(value) ? value.join(', ') : value}
      autoShow
      classNames={{ childrenClassName: 'text-bright_product' }}
    />
  </div>
);
